"use strict";

$(document).ready(function () {
    var $window = $(window);

    menu();
    anchors();
    timer();
    sliders();
    forms();


    $('.modal-video')
        .on('shown.bs.modal', function (event) {
            var $this = $(this);
            var iframe = '<iframe src="'+ $this.attr("data-iframe") +'&autoplay=1"' +
                ' frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

            $this.find(".modal-body").html(iframe);

            var $frame = $this.find("iframe");

            $frame.height($frame.width() / 16 * 9);
        })
        .on('hidden.bs.modal', function (event) {
            var $this = $(this);
            var iframe = $this.find("iframe").remove();
        });

    $("#form-ok")
        .on("shown.bs.modal", function () {
            $(this).find(".c-flash_icon").addClass("animate");
        })
        .on("hidden.bs.modal", function () {
            $(this).find(".c-flash_icon").removeClass("animate");
        });

    $("body").one("mouseleave", function () {
        $('#form-2').modal("show");
    });

    windowResize($window);
});

function menu() {
    var $root = $(".js-menu");
    var $content = $root.find(".js-menu_content");
    var $btn = $root.find(".js-menu_btn");

    $btn.data("showed", false);

    $btn.on("click", function () {
        if ( $btn.data("showed") ) {
            $content.removeClass("show-menu");
            $btn.removeClass("close-style");

            $btn.data("showed", false);
        } else {
            $content.addClass("show-menu");
            $btn.addClass("close-style");

            $btn.data("showed", true);
        }
    });
}

function anchors() {
    var $bodyHtml = $("body,html");
    var $links = $("a");

    $links.on("click", function (event) {
        var $link = $(this);
        var href = ($link.attr("href") > "" ? $link.attr("href").trim() : false);

        if ( href > "" && href.indexOf("#") === 0 ) {
            event.preventDefault();

            var position = {};
            var scrollTo = 0;

            if ( href ) {
                position = getPosition($(href));

                if ( position.top >= 0 ) {
                    scrollTo = position.top - $(".b-header").height();

                    $bodyHtml.animate({
                        scrollTop: (scrollTo > 0 ? scrollTo : 0)
                    }, 500);
                }
            }
        }
    });
}

function timer() {
    if ( !localStorage ) {
        timerEnd();

        return false;
    }

    $(".js-timer_hide-if-end").each(function () {
        if ( $(this).hasClass("btn") || $(this).hasClass("b-price__price-old") || $(this).hasClass("b-price__price-new") ) {
            $(this).css({ display: "inline-block"});
        } else {
            $(this).show();
        }
    });
    $(".js-timer_show-if-end").hide();

    var $timers = $(".js-timer");
    var $days = $timers.find(".js-timer_days");
    var $hours = $timers.find(".js-timer_hours");
    var $minutes = $timers.find(".js-timer_minutes");
    var $seconds = $timers.find(".js-timer_seconds");

    var currentTime = moment().unix();
    var eventTime = parseInt(localStorage["eventTime"], 10);
    var clearDate = $('body').attr('data-restart-timer') || false;
    var clearTime = (clearDate ? moment(Date.parse(clearDate)) : false);
    var setTimerDate = (localStorage['setEventTime'] ? moment(Date.parse(localStorage['setEventTime'])) : false);

    if ( clearTime && setTimerDate && setTimerDate.isBefore(clearTime) ) {
        eventTime = false;
    }

    if ( !eventTime || !setTimerDate ) {
        localStorage["eventTime"] = moment().subtract(-1, 'days').subtract(-8, 'hours').unix();
        localStorage["setEventTime"] = moment();

        eventTime = parseInt(localStorage["eventTime"], 10);
    }

    if ( currentTime >= eventTime ) {
        timerEnd();
    }

    var diffTime = eventTime - currentTime;
    var duration = moment.duration(diffTime*1000, 'milliseconds');
    var interval = 1000;

    var intervalFn = setInterval(function(){
        duration = moment.duration(duration - interval, 'milliseconds');

        var days = duration.days();
        var hours = duration.hours();
        var minutes = duration.minutes();
        var seconds = duration.seconds();

        if ( days === 0 && hours === 0 && minutes === 0 && seconds === 0 ) {
            timerEnd();

            clearInterval(intervalFn);
        }

        if ( $days.length > 0 ) {
            $days.text( (String(days).length === 1 ? "0"+ days : days) );
        }
        if ( $hours.length > 0 ) {
            $hours.text( (String(hours).length === 1 ? "0"+ hours : hours) );
        }
        if ( $minutes.length > 0 ) {
            $minutes.text( (String(minutes).length === 1 ? "0"+ minutes : minutes) );
        }
        if ( $seconds.length > 0 ) {
            $seconds.text( (String(seconds).length === 1 ? "0"+ seconds : seconds) );
        }
    }, interval);
}
function timerEnd() {
    $(".js-timer_hide-if-end").hide();
    $(".js-timer_show-if-end").show();
}

function sliders() {
    var $sliders = $(".js-slider");
    var $sliders4Items = $(".js-slider-4-items");

    $sliders.find(".b-slider__item").show();

    $sliders.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true
                }
            }
        ]
    });

    $sliders4Items.find(".b-slider__item").show();

    $sliders4Items.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 4000
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 4000
                }
            }
        ]
    });
}

function forms() {
    var $form = $(".js-form").first();

    $form.on("submit", function (event) {
        event.preventDefault();

        var $name = $form.find("[name='name']");
        var nameVal = $name.val().trim();
        var $email = $form.find("[name='email']");
        var emailVal = $email.val().trim();
        var $phone = $form.find("[name='phone']");
        var phoneVal = $phone.val().trim();
        var $message = $form.find("[name='message']");
        var messageVal = $message.val().trim();
        var $police = $form.find("[name='police']");
        var policeVal = $police.val();

        if ( !nameVal ) {
            $name.addClass("error");
        } else {
            $name.removeClass("error");
        }

        if ( !emailVal || emailVal.indexOf("@") < 1 ) {
            $email.addClass("error");
        } else {
            $email.removeClass("error");
        }

        if ( !phoneVal || phoneVal.length < 6 ) {
            $phone.addClass("error");
        } else {
            $phone.removeClass("error");
        }

        if ( $form.find(".error").length < 1 ) {
            $.ajax({
                url: $form.attr("action"),
                method: "post",
                data: "name="+nameVal+"&email="+emailVal+"&phone="+phoneVal+"&message="+messageVal+"&police="+policeVal,
                success: function (re) {
                    console.log("success");
                    console.log(re);

                    $name.val("");
                    $email.val("");
                    $phone.val("");
                    $message.val("");

                    $form.closest(".modal").modal("hide");

                    $("#form-ok").modal("show").find("#form-ok__name").text(nameVal);
                },
                complete: function (re) {

                },
                error: function (re) {
                    console.log("error");
                }
            });
        } else {
            $form.find(".error").first().trigger("focus");
        }

        return false;
    });
}

function windowResize($window) {
    var mobile = window.matchMedia('(max-width:767px)').matches;
    var tablet = window.matchMedia('(max-width:991px)').matches;

    var $sliders = $(".b-slider");

    var timeout = setTimeout(function () {},0);

    $window.on("resize", function () {
        mobile = window.matchMedia('(max-width:767px)').matches;
        tablet = window.matchMedia('(max-width:991px)').matches;

        clearTimeout(timeout);

        timeout = setTimeout(function () {
            if ( $(".js-menu_btn",".js-menu").data("showed") ) {
                $(".js-menu_btn",".js-menu").click();
            }

            if ( !tablet ) {
                var $collapseBtn = $(".b-collapse__btn").first();

                if ( $collapseBtn.hasClass("collapsed") ) {
                    $collapseBtn.click();
                }
            }

            $sliders.each(function () {
                var $slider = $(this);
                var sliderPadTop = parseInt($slider.css("padding-top"), 10);
                var videoHeight = $slider.find(".b-video").first().height() / 2;

                $slider.find(".slick-arrow").css({
                    top: sliderPadTop + videoHeight +"px",
                    margin: 0
                });
            });
        },100);
    });

    $window.trigger("resize");
}

/////////////////////////
function getPosition($elem) {
    var $html = $("html");
    var $body = $("body");
    var position = $body.position();

    if ( $elem[0] !== $body[0] && $elem[0] !== $html[0] ) {
        position = {top:0,left:0};

        getPos($html, $body, $elem, position);
    }

    return position;
}
function getPos($html, $body, $elem, position) {
    if ( $elem[0] !== $body[0] && $elem[0] !== $html[0] ) {
        position.top+= $elem.position().top;
        position.left+= $elem.position().left;

        getPos($html, $body, $elem.offsetParent(), position);
    }
}